module.exports = __webpack_public_path__ + "static/media/otherFilter.a8f467b6.svg";